import React, { useEffect, useState } from "react";
import {
  getSources,
  createSource,
  updateSource,
  deleteSource,
} from "../api";

export default function SourceMaster() {
  const [sources, setSources] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [sourceName, setSourceName] = useState("");
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    loadSources();
  }, []);

  async function loadSources() {
    try {
      const res = await getSources();
      setSources(res.data);
    } catch (err) {
      console.log(err);
    }
  }

  async function saveSource() {
    if (!sourceName.trim()) return;

    try {
      if (editingId) {
        await updateSource(editingId, sourceName);
      } else {
        await createSource(sourceName);
      }

      await loadSources();

      setSourceName("");
      setEditingId(null);
      setShowModal(false);
    } catch (err) {
      console.log(err);
    }
  }

  async function removeSource(id) {
    if (!window.confirm("Delete this source?")) return;

    try {
      await deleteSource(id);
      await loadSources();
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <div style={{ padding: "30px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h2>Sources</h2>

        <button
          onClick={() => {
            setEditingId(null);
            setSourceName("");
            setShowModal(true);
          }}
          style={{
            padding: "10px 20px",
            background: "#16a34a",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: 600,
          }}
        >
          + Add Source
        </button>
      </div>

      <table
        border="1"
        cellPadding="16"
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginTop: "20px",
        }}
      >
        <thead>
          <tr>
            <th>ID</th>
            <th>Source</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>

        <tbody>
          {sources.map((source) => (
            <tr key={source.id}>
              <td>{source.id}</td>

              <td>{source.source_name}</td>

              <td>
                <button
                  onClick={() => {
                    setEditingId(source.id);
                    setSourceName(source.source_name);
                    setShowModal(true);
                  }}
                  style={{
                    background: "#2563eb",
                    color: "#fff",
                    border: "none",
                    padding: "8px 18px",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                >
                  Edit
                </button>
              </td>

              <td>
                <button
                  onClick={() => removeSource(source.id)}
                  style={{
                    background: "#dc2626",
                    color: "#fff",
                    border: "none",
                    padding: "8px 18px",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
            {showModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,.35)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: 400,
              background: "#fff",
              padding: 25,
              borderRadius: 10,
            }}
          >
            <h3>
              {editingId ? "Edit Source" : "Add Source"}
            </h3>

            <input
              value={sourceName}
              onChange={(e) => setSourceName(e.target.value)}
              placeholder="Source Name"
              style={{
                width: "100%",
                padding: 10,
                marginTop: 15,
                marginBottom: 20,
              }}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 10,
              }}
            >
              <button
                onClick={() => {
                  setShowModal(false);
                  setEditingId(null);
                  setSourceName("");
                }}
              >
                Cancel
              </button>

              <button
                onClick={saveSource}
                style={{
                  background: "#16a34a",
                  color: "#fff",
                  border: "none",
                  padding: "10px 20px",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}